import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useGetClientsQuery, useGetLibrariesQuery, useInheritLibraryMutation } from '../../../generated/graphql';
import { FormAutoComplete } from '../../form';
import styles from './InheritLibraryDialog.module.css';

type InheritLibraryDialogProps = {
    onClose: () => void,
    libraryId?: string,
    clientId?: string,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const InheritLibraryDialog = (props: InheritLibraryDialogProps) => {
    const { libraryId, style, visible, onClose } = props;
    const [inheritLibrary, result] = useInheritLibraryMutation();
    const [searchClients, setSearchClients] = useState('');
    const [searchText, setSearchText] = useState('');
    const [validationError, setValidationError] = useState('');

    const clients = useGetClientsQuery({
        variables: { contains: searchClients }
    });

    const libraryData = useGetLibrariesQuery();

    const handleClientChanged = (value: string) => {
        setSearchClients(value);
        const client = clients.data?.ClientList?.nodes?.filter(l => l?.name === value)[0];
        if (client) libraryData.refetch({
            clientId: client.id,
            contains: searchText
        });
    };

    const handleSubmit = () => {
        const selected = libraryData.data?.LibraryList?.nodes?.filter(l => l?.name === searchText)[0];
        const selectedClient = clients.data?.ClientList?.nodes?.filter(l => l?.name === searchClients)[0];

        if (!searchClients || !searchText) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        if (!selectedClient) {
            setValidationError('Please Select A Valid Client!');
            return;
        }
        if (!selected) {
            setValidationError('Please Select A Valid Library!');
            return;
        }
        setValidationError('');
        inheritLibrary({
            variables: { id: libraryId, to: selected?.id }
        })
            .then(() => { onClose(); })
            .catch(() => {});
    };

    return (
        <DialogBase
            title="Add Source Library"
            type="OkCancel"
            visible={visible}
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            className={styles.InheritLibraryDialog}
            style={style}
            data-testid="InheritLibraryDialog">
            <FormAutoComplete
                label="Client"
                name="client"
                value={searchClients}
                onChange={handleClientChanged}
                options={(clients.data?.ClientList?.nodes?.map(c => c?.name) || []).filter((n): n is string => !!n)}
                menuFixed
            />
            <FormAutoComplete
                label="Library"
                name="library"
                value={searchText}
                onChange={setSearchText}
                options={(libraryData.data?.LibraryList?.nodes?.map(l => l?.name) || []).filter((n): n is string => !!n)}
                menuFixed
            />
        </DialogBase>
    );
};

export default InheritLibraryDialog;